@switch(type){
  @case("hr"){
  }
  @case("h2"){
  <h2>{{ label }}</h2>
  }
  @case("h3"){
  <h3>{{ label }}</h3>
  }
  @case("h4"){
  <h4>{{ label }}</h4>
  }
  @case("a"){
  <a matButton [href]="label" target="_blank">
    <mat-icon aria-hidden="true">open_in_new</mat-icon>
    {{ label }}
  </a>
  }
  @case("cite"){
  <div>
    <cite [class]="classes">{{ label }}</cite>
  </div>
  }
}
